<template>
  <div class="pageContent wallet">
    <pageTitle title='我的储值卡' :showRight='true' rightTitle='充值' @rightHandler='goRecharge' />
    <div>
      <div class="subTitle">
        <mu-tabs :value="activeTab" @change="handleTabChange" id="type">
          <mu-tab value="tab1" title="消费开票账户" />
          <mu-tab value="tab2" title="充值开票账户" />
        </mu-tabs>
      </div>
      <div v-if="activeTab === 'tab1'">
        <mu-refresh-control :refreshing="refreshing[0]" :trigger="trigger" @refresh="refresh" />
        <div class="mycoin">
          储值卡余额
          <h2>￥{{walletInfo.StoreCardMoney}}</h2>
          <p class="bottom">
            <router-link class="left" to="/wallet/valueCardPwdReset">
              重置支付密码&nbsp;>
            </router-link>
            <router-link class="right" to="/wallet/valueCardRule">
              查看储值优惠政策及使用规则&nbsp;>
            </router-link>
          </p>
        </div>
        <div class="demo-refresh-container">
          <div class="list">
            <div class="item" v-for="item in Records[0]" v-on:click="deleteitem(item.OperateNo)">
              <div class="date">
                {{item.OperateDate | detailDate}}
              </div>
              <div>
                <span class='strong'>{{item.PointOperateComent}}</span><br/>
                <span class='detail'>{{item.OperateRemark}}</span>
              </div>
              <div>
                <span class='num' style="font-size:0.30rem">{{item.OperateMoney | discount}}</span>
              </div>
            </div>
            <loadListTail mainTitle='暂无储值记录' mainIcon='noDetail' :noMore='loadState[0].stop' :isLoading='loadState[0].loading' :overZero='Records[0].length > 0' />
          </div>
          <div class='loading' v-if="loadState[0].loading">
            <img src="../../../static/LoadingBest.gif" />
          </div>
        </div>
      </div>
      <div v-if="activeTab === 'tab2'">
        <mu-refresh-control :refreshing="refreshing[1]" :trigger="trigger" @refresh="refresh" />
        <mu-divider/>
        <div class="demo-refresh-container">
          <div class="list">
            <div class="item" v-for="item in Records[1]" v-on:click="deleteitem(item.OperateNo)">
              <div class="date">
                {{item.OperateDate | detailDate}}
              </div>
              <div>
                <span class='strong'>{{item.PointOperateComent}}</span><br/>
                <span class='detail'>{{item.OperateRemark}}</span>
              </div>
              <div>
                <span class='num'>{{item.OperateMoney | discount}}</span>
              </div>
            </div>
          </div>
          <loadListTail mainTitle='暂无储值记录' mainIcon='noDetail' :noMore='loadState[1].stop' :isLoading='loadState[1].loading' :overZero='Records[1].length > 0' />
          <div class='loading' v-if="loadState[1].loading">
            <img src="../../../static/LoadingBest.gif" />
          </div>
        </div>
      </div>
    </div>

    <mu-dialog :open="dialog" title="" @close="closeNO">
      <div style="color:#666666;margin-bottom:1.5vh">
        您要删除这条记录吗？
      </div>
      <table style="witdh:100%">
        <tr>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeNO" label="取消" style="background-color:#cccccc ;color:white" />
          </td>
          <td align="center">
            <mu-flat-button slot="actions" @click="closeYES" label="确定" style="background-color:#27BA69 ;color:white" />
          </td>
        </tr>
      </table>
    </mu-dialog>
    <!--弹出框-->
    <mu-toast v-if="toast" v-bind:message="TellUser" @close="hideToast" id="alertline" />
  </div>
</template>

<style lang="less" scoped>
@import "../../assets/theme.less";
.subTitle {
  #type {
    background-color: white;
    button {
      color: @textColor;
    }
    button.mu-tab-active {
      color: @primaryColor;
    }
  }
}
.wallet {
  background-color: #f5f5f5;
  .open {
    text-align: center;
    a {
      font-size: 0.3rem;
      color: #27ba69;
      border: 2px solid #27ba69;
      display: inline-block;
      width: 2.8rem;
      height: 0.72rem;
      line-height: 0.67rem;
      padding: 0;
      margin-top: 1rem;
      border-radius: 2px;
    }
    p {
      margin: 0.4rem 0 0 0;
    }
    label {
      color: #999999;
      font-size: 0.28rem;
      margin: 0rem;
    }
    img {
      margin-top: 2.3rem;
      max-width: 2rem;
    }
  }
}
.mycoin {
  span {
    font-size: 0.8em;
    a {
      color: @textColor;
    }
  }
  .bottom {
    font-size: 0.24rem;
    padding-bottom: 1px;
    .left {
      float: left;
      color: #999999;
    }
    .right {
      float: right;
      color: #999999;
    }
  }
}
</style>
<script>
import api from "../../api";
import { mapGetters } from "vuex";
import Scroll from "../../utils/loading";
import loadListTail from "../../components/loadListTail";
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      activeTab: "tab1",
      Records: [[], []],
      loadState: [
        {
          loading: false,
          stop: false
        },
        {
          loading: false,
          stop: false
        }
      ],
      refreshing: [false, false],
      trigger: null,
      //储值卡开通状态
      openState: "",
      scroll: null,
      type: 0,
      //弹出标签 选择是否
      dialog: false,
      TellUser: "",
      toast: false //弹出层
    };
  },
  components: {
    loadListTail
  },
  activated() {
    this.scroll.addHandler();
    // this.initData();
  },
  deactivated() {
    this.scroll.removeHandler();
  },
  mounted() {
    this.trigger = this.$el;
    this.scroll = Scroll.Create(this, this.getData, 10, 2);
  },

  methods: {
    ...mapMutations({
      setWallet: "setG_walletInfo"
    }),

    handleTabChange(val) {
      //正在加载中不允许跳转
      var oldType = this.activeTab.substring(3, 4) - 1;
      if (this.loadState[oldType].loading || this.refreshing[oldType]) {
        return;
      }
      this.activeTab = val;
      this.type = val.substring(3, 4) - 1;
      this.scroll.changeType(this.type);
    },
    initData() {
      //清空显示数据
      this.Records.splice(this.type, 1, []);
      //初始化本页控制数据、分页参数
      this.scroll.refresh();
      this.GetMyWallet();
    },
    getData() {
      var that = this;
      var type = this.type;
      var params = new this.URLSearchParam();
      params.append("pageIndex", this.pageParam[type].index);
      params.append("pageSize", 10);
      params.append("type", type);
      return new Promise(function(resolve, reject) {
        that.$http
          .post(api.getStoreCardCashLog(), params.toParam())
          .then(res => {
            if (res.Result) {
              var temp = res.Data;
              resolve(temp.length);
              that.Records.splice(type, 1, that.Records[type].concat(temp));
            } else {
              resolve(null);
              if (res.Message == "未登录") {
                that.$router.push({ path: "/user/Login" });
              }
            }
          });
      }).catch(function(error) {
        reject();
      });
    },
    refresh() {
      this.refreshing.splice(this.type, 1, true);
      setTimeout(() => {
        this.refreshing.splice(this.type, 1, false);
        this.initData();
      }, 2000);
    },
    goRecharge() {
      this.$router.push({ path: "/wallet/recharge" });
    },

    //弹出标签 选择是否
    deleteitem(val) {
      this.dialog = true;
      this.operateNo = val;
    },
    //确定
    closeYES() {
      this.dialog = false;
      var type = this.type;
      var params = new this.URLSearchParam();
      params.append("operateNo", this.operateNo);
      params.append("type", type);
      this.$http
        .post(api.deleteStoreCardCashLog(), params.toParam())
        .then(res => {
          if (res.Result) {
            this.TellUser = res.Data.message;
            this.showToast();
            this.initData();
          } else {
            this.TellUser = res.Message.message;
            this.showToast();
          }
        });
    },
    closeNO() {
      //  拒绝取消订单
      this.dialog = false;
    },

    GetMyWallet() {
      this.$http.post(api.GetMyWallet()).then(res => {
        if (res.Result) {
          this.setWallet(res.Data);
        }
      });
    },

    // END 弹出标签 选择是否
    // 弹出层
    showToast() {
      this.toast = true;
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast = false;
      }, 1000);
      if (this.TellUser == "未登录") {
        this.$store.dispatch("clearUser");
        this.toastTimer = setTimeout(() => {
          this.$router.push({ path: "/user/login" });
        }, 1200);
      }
    },
    hideToast() {
      this.toast = false;
      if (this.toastTimer) clearTimeout(this.toastTimer);
    }
    // 弹出层
  },
  watch: {
    loginInfo: {
      handler: function(val, oldVal) {
        this.initData();
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      walletInfo: "g_walletInfo",
      loginInfo: "g_loginInfo"
    })
  }
};
</script>


// WEBPACK FOOTER //
// valueCardDetail.vue?68496bf5